@let role = role$ | async;

@if (showEmailSentDialog$ | async) {
  <dcr-dialog
    open
    headline="E-mail verzonden"
    icon="content:mail"
    type="confirm"
    (confirm)="onEmailSentDialogConfirm()"
    data-cy="request-sent-message"
    >
    <div>Check je inbox: er is een e-mail gestuurd naar het opgegeven e-mailadres om je wachtwoord opnieuw in te stellen.</div>
  </dcr-dialog>
}

<div class="[ relative container container-max-width-3xl stack ]">
  @if (mode() !== 'forgot-password') {
    <h1 class="[ headline-large text-center ]" data-cy="form-header">
      @if (role === 'schooladmin') {
        Aanmelden als schoolbeheerder
      } @else {
        Aanmelden
      }
    </h1>
  }
  @if (mode() === 'forgot-password') {
    <h1 class="[ headline-large text-center ]" data-cy="form-header">Wachtwoord vergeten</h1>
  }

  @if (isMaintenanceMode$ | async) {
    <campus-maintenance-mode
      [statusPageUrl]="statusPageUrl"
    ></campus-maintenance-mode>
  } @else {
    <dcr-animated-kai
      #kai
      src="assets/rive/kai_state_machine.riv"
      autoplay
      track-lookat
      react-to-click
      class="[ kai ][ absolute inset-is-0 inset-bs-0 transform -translate-x-2/3 w-3xs ]"
    ></dcr-animated-kai>
    <div class="[ stack flex-1 max-w-full tablet-p:min-w-m ]">
      @if (mode() !== 'sso') {
        <div class="[ p-b-m ]">
          @if (mode() === 'basic-login') {
            <polpo-login-form
              (login)="loginWithCredentials($event)"
              [showRegister]="role !== 'schooladmin'"
              (forgotPassword)="setForgotPasswordMode()"
              [error]="loginError$ | async"
            ></polpo-login-form>
          }
          @if (mode() === 'forgot-password') {
            <polpo-forgot-password-form
              (whenSubmitted)="resetPassword($event)"
              [showRegister]="role !== 'schooladmin'"
              (whenCancelled)="setLoginMode()"
              [passwordResetRequested]="passwordResetRequested$ | async"
            ></polpo-forgot-password-form>
          }
        </div>
      }
      @if (role !== 'schooladmin') {
        <div class="[ border-1 p-b-m ]" [class.border-bs]="mode() !== 'sso'">
          <polpo-login-methods
            (login)="loginWith($event)"
            (whenCancelled)="setLoginMode()"
            [provider]="provider()"
            [error]="ssoError$ | async"
          ></polpo-login-methods>
        </div>
      }
      <div class="[ border-1 border-bs p-b-m ]">
        <polpo-login-no-access [role]="role" data-cy="login-no-access"></polpo-login-no-access>
      </div>
    </div>
  }
</div>
